<template>
  <div>
    <Row style="padding: 20px">
      <Col span="18">
        <div class="status">
          <div
            :class="['status-item', tab == '0' ? 'status-item-active' : '']"
            @click="tabNav('0')"
          >
            文章列表
          </div>
          <div
            :class="['status-item', tab == '1' ? 'status-item-active' : '']"
            @click="tabNav('1')"
          >
            文章分类
          </div>
        </div>
      </Col>
      <Col span="6">
        <Button
          v-if="tab == 0"
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="openContent()"
          >添加文章</Button
        >
        <Button
          v-if="tab == 1"
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="openFn()"
          >添加分类</Button
        >
      </Col>
      <Col span="24">
        <div v-show="tab == 0">
          <Col span="24" style="margin-bottom: 20px">
            <Select
              filterable
              v-model="params.typeCode"
              placeholder="请选择分类"
              class="public-inp"
            >
              <Option
                v-for="item in all_typeList"
                :value="item.typeCode"
                :key="item.typeCode"
                >{{ item.name }}</Option
              >
            </Select>
            <Input
              v-model="params.title"
              placeholder="请输入标题"
              class="public-inp"
            />
            <Input
              v-model="params.content"
              placeholder="请输入文章内容"
              class="public-inp"
            />
            <Button type="primary" icon="md-search" @click="handleSearch()"
              >搜索</Button
            >
            <Button @click="resetList()">重置</Button>
          </Col>

          <!-- 文章列表 -->
          <Table
            class="table"
            border
            stripe
            :loading="loading"
            :columns="columns0"
            :data="contentList.list || []"
          >
            <template slot-scope="{ index }" slot="no">
              <span>{{
                params.pageSize * (params.pageNum - 1) + index + 1
              }}</span>
            </template>
            <template slot-scope="{ row }" slot="status">
              <!-- 1=启用；2=禁用 -->
              <i-switch
                :value="row.status == 1"
                @on-change="(v) => updateState(v, row, 0)"
                size="small"
              />
            </template>
            <template slot-scope="{ row }" slot="action">
              <a href="javascript:;" @click="openContent(row)">编辑</a>
              <a href="javascript:;" @click="removeContent(row)">删除</a>
            </template>
          </Table>
          <Page
            :style="{ float: 'right', marginTop: '10px' }"
            :total="contentList.total"
            :current.sync="params.pageNum"
            :page-size-opts="[10, 20, 30, 100]"
            :page-size="params.pageSize"
            show-sizer
            show-total
            prev-text="Previous"
            next-text="Next"
            show-elevator
            @on-change="(val) => pageNumChange(val, 'params')"
            @on-page-size-change="(val) => pageSizeChange(val, 'params')"
          />
        </div>
        <!-- 文章分类 -->
        <div v-show="tab == 1">
          <Table
            class="table"
            border
            stripe
            :loading="loading"
            :columns="columns1"
            :data="typeList.list || []"
          >
            <template slot-scope="{ index }" slot="no">
              <span>{{
                typeParams.pageSize * (typeParams.pageNum - 1) + index + 1
              }}</span>
            </template>
            <template slot-scope="{ row }" slot="status">
              <!-- 1=启用；2=禁用 -->
              <i-switch
                :value="row.status == 1"
                @on-change="(v) => updateState(v, row, 1)"
                size="small"
              />
            </template>
            <template slot-scope="{ row }" slot="action">
              <a href="javascript:;" @click="openFn(row)">编辑</a>
              <a href="javascript:;" @click="removeType(row)">删除</a>
            </template>
          </Table>
          <Page
            :style="{ float: 'right', marginTop: '10px' }"
            :total="typeList.total"
            :current.sync="typeParams.pageNum"
            :page-size-opts="[10, 20, 30, 100]"
            :page-size="typeParams.pageSize"
            show-sizer
            show-total
            prev-text="Previous"
            next-text="Next"
            show-elevator
            @on-change="(val) => pageNumChange(val, 'typeParams')"
            @on-page-size-change="(val) => pageSizeChange(val, 'typeParams')"
          />
        </div>
      </Col>
    </Row>

    <!-- 新增和编辑分类 -->
    <Modal
      v-model="typeModal"
      :title="typeTitle == 0 ? '添加分类' : '编辑分类'"
      :mask-closable="false"
      :loading="typeModalLoading"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="typeValidate"
        :model="typeformItem"
        :rules="ruleValidate0"
        :label-width="80"
      >
        <FormItem label="分类名称" prop="name">
          <Input
            v-model="typeformItem.name"
            placeholder="请输入分类名称"
          ></Input>
        </FormItem>
        <FormItem label="类型编码" prop="typeCode">
          <!-- :disabled="typeTitle == 1" -->
          <Input
            v-model="typeformItem.typeCode"
            placeholder="请输入分类类型编码"
          ></Input>
        </FormItem>
        <FormItem label="操作人" prop="operator">
          <Input
            v-model="typeformItem.operator"
            placeholder="请输入操作人"
          ></Input>
        </FormItem>
        <FormItem label="分类描述" prop="describe">
          <Input v-model="typeformItem.describe" type="textarea"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <!-- 1=启用；2=禁用 -->
          <i-switch
            :value="typeformItem.status == 1"
            @on-change="(v) => statusChange(v, 'typeformItem')"
            size="small"
          />
        </FormItem>
      </Form>
    </Modal>
    <!-- 新增和编辑文章 -->
    <Modal
      v-model="contentModal"
      :title="contentTitle == 0 ? '添加文章' : '编辑文章'"
      :mask-closable="false"
      :loading="contentModalLoading"
      @on-ok="addContent"
      @on-cancel="cancelContent"
      width="660"
    >
      <Form
        ref="contentValidate"
        :model="contentformItem"
        :rules="ruleValidate1"
        :label-width="80"
      >
        <FormItem label="文章标题" prop="title">
          <Input
            v-model="contentformItem.title"
            placeholder="请输入文章标题"
          ></Input>
        </FormItem>
        <FormItem label="所属分类" prop="typeCode">
          <Select
            v-model="contentformItem.typeCode"
            placeholder="请选择所属分类"
          >
            <Option
              :disabled="item.status == 2"
              v-for="(item, index) in all_typeList"
              :key="index"
              :value="item.typeCode"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="操作人" prop="operator">
          <Input
            v-model="contentformItem.operator"
            placeholder="请输入操作人"
          ></Input>
        </FormItem>
        <FormItem label="文章描述" prop="describe">
          <Input v-model="contentformItem.describe" type="textarea"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <!-- 1=启用；2=禁用 -->
          <i-switch
            :value="contentformItem.status == 1"
            @on-change="(v) => statusChange(v, 'contentformItem')"
            size="small"
          />
        </FormItem>
        <FormItem label="文章正文" prop="content">
          <div ref="editor"></div>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import E from "wangeditor";
const columns0 = [
  {
    title: "编号",
    slot: "no",
    width: 80,
  },
  {
    title: "标题",
    key: "title",
  },
  {
    title: "描述",
    key: "remark",
  },
  {
    title: "所属分类",
    key: "typeName",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
  },
];
const validateSelfHandler = (msg, rule, value, callback) => {
  if (new RegExp(rule).test("" + value)) {
    callback();
  } else {
    callback(new Error(msg));
  }
};
export default {
  data() {
    const columns1 = [
      {
        title: "编号",
        slot: "no",
        width: 80,
      },
      {
        title: "名称",
        key: "name",
      },
      {
        title: "类型编码",
        key: "typeCode",
      },
      {
        title: "操作人",
        key: "operator",
      },
      {
        title: "操作时间",
        key: "updateTime",
        render: (h, params) => {
          let text = this.tools.formatDate(params.row.updateTime, true);
          return h("span", text);
        },
      },
      {
        title: "状态",
        slot: "status",
      },
      {
        title: "操作",
        slot: "action",
      },
    ];
    return {
      tab: 0,
      params: {
        pageNum: 1,
        pageSize: 10,
        typeCode: "",
        content: "",
        title: "",
      },
      typeParams: {
        pageNum: 1,
        pageSize: 10,
      },
      contentList: {},
      typeList: {},
      loading: false,
      columns0,
      columns1,
      typeTitle: 0, //添加分类
      typeModal: false, //分类弹框
      typeformItem: {
        name: "",
        typeCode: "",
        operator: "",
        describe: "",
        status: 1, //启用
      },
      ruleValidate0: {
        name: [
          {
            required: true,
            message: "分类名称不能为空",
            trigger: "blur",
          },
        ],
        typeCode: [
          {
            required: true,
            message: "分类编码不能为空",
            trigger: "blur",
          },
        ],
        operator: [
          {
            required: true,
            message: "操作人不能为空",
            trigger: "blur",
          },
        ],
        describe: [
          {
            required: true,
            message: "分类描述不能为空",
            trigger: "blur",
          },
        ],
        status: [
          {
            type: "number",
            required: true,
            message: "分类状态不能为空",
            trigger: "change",
          },
        ],
      },
      typeModalLoading: true,

      contentTitle: 0, //添加文章
      contentModal: false, //分类弹框
      contentformItem: {
        content: "",
        describe: "",
        operator: "",
        status: 1,
        title: "",
        typeCode: "",
      },
      ruleValidate1: {
        title: [
          {
            required: true,
            message: "文章标题不能为空",
            trigger: "blur",
          },
          {
            required: true,
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "不为空且不能超过20个字符",
                /^.{1,20}$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
        typeCode: [
          {
            required: true,
            message: "所属分类不能为空",
            trigger: "change",
          },
        ],
        operator: [
          {
            required: true,
            message: "操作人不能为空",
            trigger: "blur",
          },
        ],
        describe: [
          {
            required: true,
            message: "文章描述不能为空",
            trigger: "blur",
          },
          {
            required: true,
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "不能超过100个字符",
                /^.{1,100}$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
        status: [
          {
            type: "number",
            required: true,
            message: "分类状态不能为空",
            trigger: "change",
          },
        ],
        content: [
          { required: true, message: "请输入文章内容", trigger: "blur" },
        ],
      },
      contentModalLoading: true,
      all_typeList: [], //所有分类
      editor: null,
    };
  },
  mounted() {
    this.editorHandler();
  },
  created() {
    this.getList();
    this.getAllType();
  },
  methods: {
    editorHandler() {
      const self = this;
      this.editor = new E(this.$refs.editor);
      this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        const fd = new FormData();
        fd.append("file", resultFiles[0]);
        self.$store
          .dispatch("uploadImage", fd)
          .then((res) => {
            if (res.code == 200) {
              insertImgFn(res.data.url);
            } else {
              self.$Message.error("图片上传失败");
            }
          })
          .catch((err) => {
            self.$Message.error("图片上传失败");
          });
      };
      // 配置 onchange 回调函数
      this.editor.config.onchange = function (newHtml) {
        self.contentformItem.content = newHtml;
      };
      // 配置触发 onchange 的时间频率，默认为 200ms
      this.editor.config.onchangeTimeout = 500;
      this.editor.create();
      this.editor.txt.html(this.contentformItem.content); // 重新设置编辑器内容
    },
    getAllType() {
      this.$api.conTypeList({ pageNum: 1, pageSize: 99999 }).then((res) => {
        if (res.code == 200) {
          this.all_typeList = res.data.list;
        }
      });
    },
    openFn(d) {
      this.typeTitle = d ? 1 : 0;
      if (d) {
        Object.keys(this.typeformItem).forEach((key) => {
          this.typeformItem[key] = d[key];
        });
        this.typeformItem.describe = d.remark;
        this.typeformItem.id = d.id;
      }
      this.$nextTick(() => {
        this.typeModal = true;
      });
    },
    tabNav(e) {
      this.tab = e;
      let d = e == 0 ? "params" : "typeParams";
      this[d].pageNum = 1;
      this[d].pageSize = 10;
      this.getList();
    },
    handleSearch() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.getList();
    },
    getList() {
      this.loading = true;
      let params = {};
      if (this.tab == 0) {
        params = this.params;
        this.$api
          .contentList(params)
          .then((res) => {
            if (res.code == 200) {
              this.getAllType();
              this.loading = false;
              this.contentList = res.data;
            }
          })
          .finally((err) => {
            this.loading = false;
          });
      } else {
        params = this.typeParams;
        this.$api
          .conTypeList(params)
          .then((res) => {
            if (res.code == 200) {
              this.loading = false;
              this.typeList = res.data;
            }
          })
          .finally((err) => {
            this.loading = false;
          });
      }
    },

    // 页码
    pageNumChange(pageNum, tab) {
      this[tab].pageNum = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize, tab) {
      this[tab].pageSize = pageSize;
      if (this[tab].pageNum == 1) {
        this.getList();
      } else {
        this[tab].pageNum = 1;
      }
    },
    // 分类新增和编辑
    addAction() {
      this.typeModalLoading = false;
      this.$nextTick(() => {
        this.typeModalLoading = true;
      });
      let data = { ...this.typeformItem };
      let http = "conTypeAdd";
      this.$refs["typeValidate"].validate((valid) => {
        if (valid) {
          if (this.typeTitle == 1) {
            http = "conTypeUpt";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.getList();
            }
          });
        }
      });
    },
    //分类的取消按钮
    cancelAction() {
      Object.keys(this.typeformItem).forEach((key) => {
        this.typeformItem[key] = "";
      });
      this.$refs["typeValidate"].resetFields();
      this.typeModal = false;
    },
    openContent(d) {
      this.contentTitle = d ? 1 : 0;
      if (d) {
        Object.keys(this.contentformItem).forEach((key) => {
          this.contentformItem[key] = d[key];
        });
        this.contentformItem.describe = d.remark;
        this.contentformItem.id = d.id;
        if (this.editor) {
          this.editor.txt.html(this.contentformItem.content);
        }
      }
      this.$nextTick(() => {
        this.contentModal = true;
      });
    },
    addContent() {
      this.contentModalLoading = false;
      this.$nextTick(() => {
        this.contentModalLoading = true;
      });
      let data = { ...this.contentformItem };
      let http = "contentAdd";
      this.$refs["contentValidate"].validate((valid) => {
        if (valid) {
          if (this.contentTitle == 1) {
            http = "contentUpt";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelContent();
              this.getList();
            }
          });
        }
      });
    },
    // 文章弹框取消
    cancelContent() {
      Object.keys(this.contentformItem).forEach((key) => {
        this.contentformItem[key] = "";
      });
      if (this.editor) {
        this.editor.txt.html(this.contentformItem.content);
      }
      this.$refs["contentValidate"].resetFields();
      this.contentModal = false;
    },
    // 分类删除
    removeType(row) {
      let id = row.id;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除该分类吗`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api
            .conTypeDel({ id: id })
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success("删除成功");
                this.getList();
              } else {
                this.$Message.error("删除失败");
              }
            })
            .catch((err) => {
              this.$Message.error(res.message);
            });
        },
      });
    },
    // 文章删除
    removeContent(row) {
      let id = row.id;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除该文章吗`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api
            .contentDel({ id: id })
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success("删除成功");
                this.getList();
              } else {
                this.$Message.error("删除失败");
              }
            })
            .catch((err) => {
              this.$Message.error(res.message);
            });
        },
      });
    },
    // 修改状态
    statusChange(e, tab) {
      this[tab].status = e ? 1 : 2;
    },
    resetList() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.params.typeCode = "";
      this.params.content = "";
      this.params.title = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    updateState(v, d, tab) {
      d.status = v ? 1 : 2;
      delete d.createTime;
      delete d.updateTime;
      let http = tab == 0 ? "contentUpt" : "conTypeUpt";
      this.$api[http](d).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
  },
};
</script>

<style scoped>
.status {
  max-width: 40%;
  display: flex;
  margin-bottom: 15px;
}

.status .status-item {
  width: 100px;
  text-align: center;
  height: 32px;
  line-height: 30px;
  font-size: 12px;
  padding: 0 20px;
  cursor: pointer;
  user-select: none;
  transition: 0.25s;
  outline: none;
  background-color: #fff;
  color: #5586ff;
  border: 1px solid #5586ff;
  white-space: nowrap;
}

.status .status-item:first-child {
  border-radius: 4px 0 0 4px;
}

.status .status-item:last-child {
  border-radius: 0 4px 4px 0;
}

.status .status-item:not(:first-child) {
  margin-left: -1px;
}

.status .status-item-active {
  color: #fff;
  border-color: #5586ff;
  background-color: #5586ff;
}
.table {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/content/list.vue